import React, { Component } from "react";
import "./Chat.css";
import Messages from "./Messages";
import AddMessage from "./AddMessage";

export default class Chat extends Component {

  render() {
    return (
      <div id="chat">
        <Messages messages={this.props.messages} client={this.props.client} />
        <AddMessage handleSend={this.props.handleSend} readonly={this.props.readonly} />
      </div>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/chat/Chat.js